import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { api, type Me } from "./api";
import { Dialog, ErrorMessage } from "./components";
import { DivisionPicker } from "./DivisionPicker";

/** Asked once, before someone's first key: every key is labelled with where its spend belongs. */
export function OnboardingDialog({ me, open, onClose, onSaved }: { me: Me; open: boolean; onClose: () => void; onSaved: () => void }) {
  const qc = useQueryClient();
  const [division, setDivision] = useState("");
  const [businessUnit, setBusinessUnit] = useState("");
  const save = useMutation({
    mutationFn: () => api.onboard(division, businessUnit),
    onSuccess: async () => { await qc.invalidateQueries({ queryKey: ["me"] }); onSaved(); },
  });
  return (
    <Dialog open={open} onClose={onClose} label="Your division and business unit">
      <h2 className="forge-typography--heading3 card-title">Before your first key</h2>
      <p className="forge-typography--body2">
        Every key is labelled with the division and business unit it is used for, so AI spend is reported to the right
        part of the company. We could not find yours on record.
      </p>
      <DivisionPicker taxonomy={me.taxonomy} division={division} businessUnit={businessUnit}
        onChange={(d, b) => { setDivision(d); setBusinessUnit(b); }} />
      <p className="forge-typography--body1 muted">
        Only an administrator can change this afterwards. In production this may be filled in for you from HR records.
      </p>
      {save.error && <ErrorMessage error={save.error} />}
      <div className="row gap-small">
        <forge-button variant="raised" disabled={!division || !businessUnit || save.isPending || undefined}
          onClick={() => save.mutate()}>Save and continue</forge-button>
        <forge-button onClick={onClose}>Not now</forge-button>
      </div>
    </Dialog>
  );
}
